import * as types from "./types";
import { http } from "../../../utils/http";

const initialState = {
  message: "",
};

export const getServicesRequest = () => ({
  type: types.GET_SERVICES_REQUEST,
  payload: {
    loading: true,
    message: "fetching",
  },
});

export const getServicesSuccess = (services) => ({
  type: types.GET_SERVICES_SUCCESS,
  payload: {
    services,
    loading: false,
    message: "success",
  },
});

export const getServicesFailure = (error) => ({
  type: types.GET_SERVICES_FAILURE,
  payload: {
    error,
    loading: false,
    message: "failure",
  },
});

export const getServices = () => (dispatch) => {
  dispatch(getServicesRequest());
  return http
    .get("/api/services/")
    .then((res) => {
      dispatch(getServicesSuccess(res.data.results));
    })
    .catch((error) => {
      dispatch(getServicesFailure(error));
    });
};

export const servicesSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SERVICES_REQUEST:
      return { ...state, ...action.payload };
    case types.GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload.services,
        message: action.payload.message,
        loading: action.payload.loading,
      };
    case types.GET_SERVICES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        message: action.payload.message,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default servicesSearchReducer;
